export function maxLength(maxLength: number) {
    return {
        max: maxLength,
        message: `Up to ${maxLength} characters in length.`,
    };
}
